module.exports = __webpack_public_path__ + "d308073b/img/scraper-icon.df6ccde5.svg";